import { Outlet } from 'react-router-dom';

/** 知识库列表与文档编辑子路由 */
export default function KnowledgeBasesLayout() {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <Outlet />
    </div>
  );
}
